// **********************************************************
// Services Slider
// **********************************************************

const servicesSliderMain = document.querySelectorAll('[data-slider="services-slider-main"]');
const servicesSliderThumb = document.querySelectorAll('[data-slider="services-slider-thumb"]');

const servicesSliderThumbOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  breakpoints: {
    767: {
      slidesPerView: 2,
    },
    1023: {
      slidesPerView: 4,
    },
  },
};

servicesSliderThumb.forEach((ele) => {
  const servicesSlider = ele.closest('.services-slider');
  const slides = servicesSlider.querySelectorAll('.services-slider__init .swiper-slide');

  if (slides.length < 5) {
    servicesSliderThumbOptions.breakpoints = {
      767: {
        slidesPerView: 2,
      },
      1023: {
        slidesPerView: slides.length,
      },
    };
  }

  new Swiper(ele, servicesSliderThumbOptions);
});

const servicesSliderMainOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  speed: 1000,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: false,
  },
  breakpoints: {
    1023: {
      spaceBetween: 90,
    },
    1199: {
      spaceBetween: 136,
    },
  },
};

servicesSliderMain.forEach((el, i) => {
  const servicesSlider = el.closest('.services-slider');
  const arrowRight = servicesSlider.querySelector('.swiper-button-next');
  const arrowLeft = servicesSlider.querySelector('.swiper-button-prev');

  servicesSliderMainOptions.navigation.nextEl = arrowRight;
  servicesSliderMainOptions.navigation.prevEl = arrowLeft;

  servicesSliderMainOptions.thumbs.swiper = servicesSliderThumb[i].swiper;
  new Swiper(el, servicesSliderMainOptions);
});
